module.exports = __webpack_public_path__ + "img/venus23.cad527b5.png";